import HistoryIcon from "@mui/icons-material/History";
import CategoryIcon from "@mui/icons-material/Category";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

export const filterOptions = {
  operations: [
    { value: "CREATE", label: "Create" },
    { value: "UPDATE", label: "Update" },
    { value: "DELETE", label: "Delete" },
  ],
  module: [
    { value: "BusinessUnit", label: "Business Unit" },
    { value: "ClientIndustry", label: "Client Industry" },
    { value: "ClientDesignation", label: "Client Designation" },
    { value: "ResourceSkillMapping", label: "Resource Skills" },
    { value: "Client", label: "Client" },
    { value: "SkillCategory", label: "Skill Category" },
    { value: "Skill", label: "Skill" },
    { value: "Projects", label: "Project" },
    { value: "Resource", label: "Resource" },
    { value: "Country", label: "Country" },
    { value: "City", label: "City" },
    { value: "Role", label: "Role" },
    { value: "RoleCategory", label: "Role Category" },
    { value: "ClientPOC", label: "Client POC" },
    { value: "ProjectsResourceMapping", label: "Project Resource Mapping" },
  ],
  status: [
    { value: "success", label: "Success" },
    { value: "error", label: "Error" },
  ],
};

export const columnFilters = [
  {
    field: "operation",
    label: "Operation",
    type: "select",
    options: filterOptions.operations,
    icon: <HistoryIcon />,
    multiple: true,
  },
  {
    field: "module",
    label: "Module",
    type: "select",
    options: filterOptions.module,
    icon: <CategoryIcon />,
    multiple: true,
  },
  {
    field: "status",
    label: "Status",
    type: "select",
    options: filterOptions.status,
    icon: <CheckCircleIcon />,
    multiple: true,
  },
  {
    field: "email_id",
    label: "Updated By",
    type: "select",
    options: [],
    icon: <CheckCircleIcon />,
    multiple: true,
  },
  {
    field: "dateRange",
    label: "Date Range",
    type: "daterange",
    icon: <CalendarTodayIcon />,
    multiple: false,
  },
];
